export const REACT_APP_COMMIT_REF = process.env.REACT_APP_COMMIT_REF;
export const REACT_APP_SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

// IMPORTANT NOTE: There client-specific env variables are ONLY USED IN the LOCAL DEVELOPMENT environment
export const NODE_ENV_IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const REACT_APP_CLIENT = process.env.REACT_APP_CLIENT;
export const REACT_APP_CLIENT_STYLES = process.env.REACT_APP_CLIENT_STYLES;

// only used in local builds
export const REACT_APP_LOCAL_BUILD = process.env.REACT_APP_LOCAL_BUILD;
